<div class="person-header-container" [class.person-header-container--profile]="layout === 'profile'"
  [class.person-header-container--collapsed]="collapseProgress >= 1" [style.--profile-collapse]="collapseProgress"
  [style.--profile-secondary-rows]="(1 - collapseProgress) + 'fr'">
  <div class="header-content">

    <!-- ==================== PHOTO SECTION ==================== -->
    <app-entity-photos [id]="person.id" [displayName]="getFullName()" />

    <!-- ==================== MAIN CONTENT SECTION ==================== -->
    <div class="header-title-section">

      <!-- Full Name -->
      <div class="person-name-row">
        <h1 class="person-name">{{ getFullName() }}</h1>
        <span *ngIf="person.hasActiveUser" class="linked-user-button" matTooltip="Este miembro tiene un usuario"
          aria-label="Este miembro tiene un usuario">
          <mat-icon>account_circle</mat-icon>
        </span>
      </div>

      <div class="person-details">
        <!-- Community -->
        <div class="person-info person-info--community">
          <mat-icon class="field-icon" matTooltip="Comunidad" aria-label="Comunidad">church</mat-icon>
          <span class="community-name">
            <ng-container *ngIf="layout === 'profile'">Comunidad: </ng-container>
            <a (click)="navigateToCommunity(person.communityId)" class="community-link">
              {{ person.communityName }}
            </a>
          </span>
          <div class="profile-status-badges" [attr.inert]="collapseProgress >= 1 ? '' : null">
          <app-spiritual-stage-badge [stage]="person.spiritualStage" matTooltip="Estado Sacramental" />
          <button *ngIf="canManageMemberData$ | async; else readonlyStatusBadge" type="button" class="status-badge-button"
            matTooltip="Cambiar estado de concurrencia" aria-label="Cambiar estado de concurrencia"
            (click)="openStatusDialog()">
            <app-membership-status-badge [status]="person.status" />
          </button>
          <ng-template #readonlyStatusBadge>
            <app-membership-status-badge [status]="person.status" matTooltip="Estado Concurrencia" />
          </ng-template>
          </div>
        </div>

        <div class="profile-secondary" [attr.inert]="collapseProgress >= 1 ? '' : null"><div class="profile-secondary-inner">
        <!-- Ministry with Status Badge -->
        <div class="person-info person-info--ministry" *ngIf="ministryActivityLines.length">
          <div class="ministry-activity-list">
            <div class="ministry-activity-line" *ngFor="let line of ministryActivityLines">
              <mat-icon class="field-icon" matTooltip="Ministerio" aria-label="Ministerio">volunteer_activism</mat-icon>
              <span class="ministry-activity-text"><span class="ministry-name">{{ line.activities.join(', ') }}</span><app-ministry-status-badge *ngIf="line.ministryStatus && line.ministryStatus !== 'Active'" [status]="line.ministryStatus" matTooltip="Estado Ministerial" /><ng-container *ngIf="line.units.length"> en <ng-container *ngFor="let unit of line.units; let last = last"><a class="ministry-unit" *ngIf="unit.id; else ministryActivityUnitName" [href]="'/units/' + unit.id" (click)="navigateToMinistryUnit($event, unit.id)">{{ unit.name }}</a><ng-template #ministryActivityUnitName>{{ unit.name }}</ng-template>{{ last ? '' : ', ' }}</ng-container></ng-container></span>
            </div>
          </div>
        </div>

        <!-- Birth and Age info -->
        <div class="person-info person-info--birth">
          <mat-icon class="field-icon" matTooltip="Fecha de nacimiento" aria-label="Fecha de nacimiento">cake</mat-icon>
          <span class="birth-date" *ngIf="person.dateOfBirth">
            {{ formatDateOfBirth(person.dateOfBirth) }}
            <span class="age">({{ age }} a&ntilde;os) </span>
            <app-age-status-badge [status]="person.ageStatus" />
          </span>
        </div>
        </div></div>
      </div>

    </div>

    <!-- ==================== MENU BUTTON ==================== -->
    <button *ngIf="canManageMemberData$ | async" mat-icon-button [matMenuTriggerFor]="menu" class="menu-button"
      aria-label="Opciones">
      <mat-icon>more_vert</mat-icon>
    </button>

    <!-- Action Menu -->
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onMenuAction('edit')">
        <mat-icon>edit</mat-icon>
        <span>Editar</span>
      </button>
      <button mat-menu-item (click)="onMenuAction('events')">
        <mat-icon>volunteer_activism</mat-icon>
        <span>Actividad e Hitos</span>
      </button>
      <button mat-menu-item (click)="onMenuAction('community-transfer')">
        <mat-icon>swap_horiz</mat-icon>
        <span>Pases de comunidad</span>
      </button>
      <button *ngIf="canManageMemberData$ | async" mat-menu-item (click)="onMenuAction('status')">
        <mat-icon>published_with_changes</mat-icon>
        <span>Cambiar estado</span>
      </button>
      <button *ngIf="canManageMemberData$ | async" mat-menu-item (click)="onMenuAction('home-attendance')">
        <mat-icon [svgIcon]="person.isHomeAttended ? 'not-home-attendance' : 'home-attendance'"></mat-icon>
        <span>{{ person.isHomeAttended ? 'Quitar atención en el hogar' : 'Marcar como atendido en el hogar' }}</span>
      </button>
      <button *ngIf="(isAdmin$ | async) && !person.hasLinkedUser" mat-menu-item (click)="onMenuAction('create-user')">
        <mat-icon>person_add</mat-icon>
        <span>Crear usuario</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item class="danger-menu-item" (click)="onMenuAction('delete')">
        <mat-icon>delete</mat-icon>
        <span>Eliminar</span>
      </button>
    </mat-menu>

  </div>
</div>
